import format from 'date-fns/format'

export const formatDateTime = (datetime) => {
    if (datetime) {
        return format(datetime, 'dd.MM.yyyy HH:mm');
    }
    return null;
}

export const custformat = (date, format = "yyyy/MM/dd") => {
    if (!date) return "";

    const d = new Date(date);
    if (isNaN(d)) return ""; // Handle invalid date

    if (typeof format !== "string") return "Invalid format"; // Prevents crashes

    const replacements = {
        yyyy: d.getFullYear(),
        yy: d.getFullYear().toString().slice(-2),
        MM: (d.getMonth() + 1).toString().padStart(2, "0"),
        M: (d.getMonth() + 1),
        dd: d.getDate().toString().padStart(2, "0"),
        d: d.getDate(),
        HH: d.getHours().toString().padStart(2, "0"),
        H: d.getHours(),
        mm: d.getMinutes().toString().padStart(2, "0"),
        m: d.getMinutes(),
        ss: d.getSeconds().toString().padStart(2, "0"),
        s: d.getSeconds(),
        MMMM: d.toLocaleString("en-US", { month: "long" }),
        MMM: d.toLocaleString("en-US", { month: "short" })
    };

    return format.replace(/yyyy|yy|MMMM|MMM|MM|M|dd|d|HH|H|mm|m|ss|s/g, match => replacements[match] || match);
};



export const formatDate = (date) => {
    try {
        if (date) {
            return format(date, 'dd.MM.yyyy');
        }
    } catch (excp) {

    }

    return null;
}

export const formatDateForApi = (date) => {
    if (date) {
        try {
            return format(date, 'yyyy-MM-dd');
        } catch (exc) {

        }

    }
    return null;
}

export const formatDonemForApi = (date) => {
    if (date) {
        return format(date, 'yyyy-MM');
    }
    return null;
}

export const parseAndFormatDateTime = (datetime) => {
    if (datetime) {
        return format(new Date(datetime), 'dd.MM.yyyy HH:mm');
    }
    return "";
}

export const parseAndFormatDate = (date) => {
    if (date) {
        return format(new Date(date), 'dd.MM.yyyy');
    }
    return "";
}

export const InputformatDate = (date) => {
    try {

        if (!date) return null;
        // Convert to ISO string and extract the desired part
        const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return offsetDate.toISOString(); // returns full ISO date: "YYYY-MM-DDTHH:mm:ss.sssZ"
    } catch (exc) { }

};

export const InputformatJustDate = (date) => {
    try {
        if (!date) return null;
        // Convert to ISO string and extract the desired part
        const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

        // Format the date to 'YYYY-MM-DD'
        const year = offsetDate.getFullYear();
        const month = String(offsetDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(offsetDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`; // Returns 'YYYY-MM-DD'
    } catch (exc) {
        console.error(exc);
        return null;
    }
};


export const TransToTimeSpan = (date) => {
    if (!date || isNaN(date)) {
        return null; // Return null for invalid or null dates
    }
    return format(date, 'HH:mm:ss'); // Format the date as HH:mm:ss
}

export const DisplayformatDate = (input) => {
    // Check if input matches the format YYYY-MM-DD using RegExp
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(input)) return null;

    const date = new Date(input);

    // Check if the input is a valid date and not "Invalid Date"
    const isValidDate = !isNaN(date.getTime());

    // Check if the parsed date matches the original input (to prevent issues like 2023-02-31)
    const [year, month, day] = input.split('-');
    if (
        isValidDate &&
        date.getUTCFullYear() == year &&
        date.getUTCMonth() + 1 == parseInt(month) &&
        date.getUTCDate() == parseInt(day)
    ) {
        // Format as dd.MM.yyyy
        const dd = String(date.getUTCDate()).padStart(2, '0');
        const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
        const yyyy = date.getUTCFullYear();

        return `${dd}.${mm}.${yyyy}`;
    }

    return null;
}
